import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';
import { styled, type StyledProps } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const EmptyValue: ComponentType<
	ClassAttributes<HTMLSpanElement> & HTMLAttributes<HTMLSpanElement> & StyledProps
> = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
	styled.span({
		color: token('color.text.subtlest'),
	});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export { EmptyValue as default };
